import Swal from 'sweetalert2'
import moment from 'moment';

export default {
    name: 'Add',
    created() {

        //this.GetAllApplications();
    },
    components: {

        
       
    },
    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            // return moment(date).format('MMMM Do YYYY, h:mm:ss a');
            return moment(date).format('MMMM Do YYYY');
        }
    },
    data() {
        return {

            AllApplications: [],
            ApplicationId: 0,
            TriggersCount: 0,


            ruleForm: {
                Name: '',
                MunicipalitId: '',
                EngilshName: '',
                TriggersCount: 0,
                ChairCount: 0,
            },
            rules: {
                ApplicationId: [
                    { required: true, message: 'الرجاء  اختيار البلدية', trigger: 'blur' },
                ],
                TriggersCount: [
                    { required: true, message: 'الرجاء إدخال عدد المشغلات', trigger: 'blur' },
                ],
            },
            
        };
    },
    methods: {

        GetAllApplications() {
            this.$blockUI.Start();
            this.$http.GetAllApplications()
                .then(response => {
                    this.$blockUI.Stop();
                    this.AllApplications = response.data.info;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });

        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.AddUsedTrigger(formName);
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
      
        AddUsedTrigger(formName) {
           
            this.$blockUI.Start();
            this.$http.AddUsedTrigger(this.ApplicationId , this.TriggersCount)
                .then(response => {
                    this.resetForm(formName);
                    this.$blockUI.Stop();
                    Swal.fire({
                        icon: 'success',
                        title: '..نجـاح العملية',
                        // text: '<strong>Something went wrong!</strong>',
                        html:
                            response.data,
                        // showCloseButton: true,
                        showCancelButton: false,
                        //confirmButtonText: `حـفظ`,
                        //denyButtonText: `مواق`,
                    }).then(() => {
                        
                    });
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$notify({
                        title: 'خطأ بعملية الاضافة',
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                        message: err.response.data
                    });
                });
        }


        

    }
}
